export default {
	name: 'FHU AGROL',
	address: 'Oblekoń 156A, 28-133 Pacanów',
	website: 'https://system.agrolsklep.pl',
	isLite: false,
	isNettoBruttoEnabled: true, // if enabled user can select "brutto" or "netto", if disabled than "brutto" is set
	isCommissionFieldVisible: true,
	isCalculateCommissionEnabled: false,
	isMultiCurrencyEnabled: true, // if enabled user can choose currency
	canNonAdminSeeRouteAsAdmin: false,
	canNonAdminSeeTopButtons: false,
	canChangeStartPoint: true,
	agentsCanEditEverything: true,
	agentsCanSeeRouteTotals: true,
	shouldPDFRouteViewIncludeMap: true,
	shouldDOCRouteViewIncludeMap: true,
	isRouteProductionPdfAvailable: true,
	isRouteProductionDocAvailable: false,
	isStateFieldEnabled: true,
	isInProductionStatusEnabled: false,
	isFilterByCountryEnabled: false,
	canDuplicateOrder: false,
	perPageOptions: [5, 10, 25, 50, 100],
	canSendAsUser: false,
	canSendWithGmail: false,
	canSortByCreatedDate: false,
	isSystemMailerOptionVisible: true,
	canMoveToTrash: false,
	canMoveToComplaints: false,
	isMultipleOrderAttachmentsEnabled: false,
	isRouteDocumentAttachmentEnabled: false,
	isGroundPreparedEnabled: false,
	isConceptEnabled: false,
	isDistanceFromRoadEnabled: false,
	isGroundPreparationDateEnabled: false,
	isNotesEnabled: false,
	isPaidEnabled: false,
	shouldShowComplaintsInPendingTab: true,
	orderStatusNames: {
		new: 'NOWE',
		pending: 'OCZEKUJĄCE',
		planned: 'PLANOWANE',
		inProduction: 'PRODUKCJA',
		sent: 'WYSŁANE',
		archived: 'ARCHIWUM',
		trashed: 'KOSZ',
		complaint: 'REKLAMACJA',
		all: 'WSZYSTKIE'
	},
	orderPriceLabel: 'Cena'
}
